export const PRICING_TITLE = "지금은 무료로 다 쓰실 수 있습니다";
export const PRICING_LEAD = "문의부터 준공까지 모든 기능이 무료 요금제에 들어 있습니다. 더 큰 요금제는 준비 중입니다.";
